export const selectCanvasToolbarState = ({ video }) => video.showCanvasToolbar
